<div class="tab-nav" [ngClass]="{ 'py-2': editMode }">
  <div class="tab-nav__left">
    <div
      class="tab-nav__left__items"
      cdkDropListOrientation="horizontal"
      cdkDropList
      (cdkDropListDropped)="drop($event)"
    >
      <div mat-tab-nav-bar *ngIf="!editMode; else tabEditMode">
        <div
          class="tab-nav__left__items__item"
          *ngFor="let tab of tabs"
          (click)="editMode ? null : tabChange.emit(tab.id)"
          mat-tab-link
          [active]="tab.id === tabId"
          [disabled]="editMode"
        >
          {{ tab.name }}
        </div>
      </div>
      <ng-template #tabEditMode>
        <div
          class="tab-nav__left__items__edit-item"
          *ngFor="let tab of tabs"
          cdkDragBoundary=".tab-nav__left__items__item"
          cdkDragLockAxis="x"
          cdkDrag
          [cdkDragDisabled]="!editMode"
        >
          <mat-icon *ngIf="editMode" cdkDragHandle class="drag-icon">drag_indicator</mat-icon>
          {{ tab.name }}
          <div class="tab-nav__left__items__edit-item__actions" *ngIf="editMode && tabId !== tab.id">
            <mat-icon
              matTooltip="Edit Tab Title"
              svgIcon="edit"
              class="mat-sm-icon edit-tab-title-control"
              (click)="openTabPanel(tab)"
            ></mat-icon>
            <mat-icon
              matTooltip="Remove Tab"
              svgIcon="delete"
              class="mat-sm-icon remove-tab-control"
              (click)="removeTab(tab)"
            ></mat-icon>
          </div>
        </div>
      </ng-template>
    </div>
    <ng-container *ngIf="editMode">
      <button class="px-3 mr-1 mt-1 ml-3" mat-button #tabPanelOrigin (click)="openTabPanel()">
        <mat-icon class="icon-size-20 mr-2" svgIcon="add_circle"></mat-icon>
        <span>Add Tab</span>
      </button>
      <button class="px-3 mr-1 mt-1 ml-3" mat-button [matMenuTriggerFor]="addPanelMenu">
        <mat-icon class="icon-size-20 mr-2" svgIcon="add_circle"></mat-icon>
        <span>Add Panel</span>
      </button>
    </ng-container>
  </div>
  <div class="tab-nav__right pr-4">
    @if (!editMode && canEditLayout) {
      <ts-button type="stroked" color="accent" (click)="toggleEditMode.emit()">
        <ts-icon [icon]="'edit'"></ts-icon>
        Edit Layout
      </ts-button>
    }
    @if (editMode) {
      <ts-button class="pr-2" type="flat" color="warn" (click)="saveLayout(true)">
        <ts-icon [icon]="'close'"></ts-icon>
        Cancel
      </ts-button>
      <ts-button type="flat" color="success" (click)="saveLayout()">
        <ts-icon [icon]="'save'"></ts-icon>
        Save
      </ts-button>
    }
  </div>
</div>

<mat-menu #addPanelMenu>
  <ng-container *ngFor="let panel of panels">
    <button mat-menu-item (click)="panelAdded.emit(panel)">
      <mat-icon svgIcon="add"></mat-icon>
      <span>{{ panel.title }}</span>
    </button>
    <mat-divider *ngIf="panels.length > 1"></mat-divider>
  </ng-container>
</mat-menu>

<ng-template #tabPanel>
  <div class="tab-form">
    <form [formGroup]="tabForm">
      <input formControlName="id" type="hidden" />
      <input formControlName="name" type="text" placeholder="Tab Name" [maxLength]="25" />
      <button
        type="submit"
        matTooltip="Save Tab"
        mat-icon-button
        (click)="saveTab()"
        [disabled]="tabForm.get('name').errors"
      >
        <mat-icon svgIcon="save"></mat-icon>
      </button>
    </form>
  </div>
</ng-template>
